// src/app/service/api/password-recovery.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom, throwError, timeout, catchError, map } from 'rxjs';

export interface RecoveryVerifyResponse {
  result: 0 | 1;
  id_usuario?: string;
  message?: string;
}

export interface ApiError {
  status: number;
  message: string;
  raw?: unknown;
}

@Injectable({ providedIn: 'root' })
export class PasswordRecoveryService {
  private readonly base = environment.serverUrl;

  constructor(private readonly http: HttpClient) {
    void HttpClient;
  }

  async sendEmail(email: string): Promise<boolean> {
    const url = this.base + 'ws/user/sendPasswordRecovery.php';
    const params = new HttpParams()
      .set('email', (email ?? '').trim());

    await firstValueFrom(
      this.http.get(url, { params }).pipe(
        timeout(15000),
        map(() => true),
        catchError((err) => throwError(() => this.normalizeError(err)))
      )
    );
    return true;
  }

  verify(code: string): Promise<any> {
    const url = this.base + 'ws/user/checkCode.php';
    const params = new HttpParams().set('code', (code ?? '').trim());

    return firstValueFrom(
      this.http.get<RecoveryVerifyResponse>(url, { params }).pipe(
        timeout(15000),
        map((r) => ({
          result: (r?.result ?? 0) as 0 | 1,
          id_usuario: r?.id_usuario,
          message: r?.message
        })),
        catchError((err) => throwError(() => this.normalizeError(err)))
      )
    );
  }

  private normalizeError(err: unknown): ApiError {
    const http = err as HttpErrorResponse;
    const status = http?.status ?? 0;
    const backendMsg =
      (http?.error ?? (http.error.message ?? http.error?.msg ?? http.error?.error)) ??
      (typeof http?.error === 'string' ? http.error : undefined);

    const message =
      backendMsg ??
      http?.statusText ??
      'Network or server error. Please try again.';

      console.log(status, message);
    return { status, message, raw: err };
  }
}
